import { useI18n } from '../i18n';
import LanguageSelect from '../components/LanguageSelect';

export default function Footer() {
  const { t } = useI18n();
  const year = new Date().getFullYear();

  return (
    <footer className="border-t-2 border-[#FDE68A] bg-[#FFFBEB] px-6 py-12">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-6 md:flex-row">
        <a href="#" className="font-['Russo_One'] text-2xl uppercase tracking-tight text-[#78350F]">
          Amber<span className="text-[#F59E0B]">Bytes</span>
        </a>
        <nav className="flex flex-wrap justify-center gap-6">
          <a href="#services" className="text-sm font-semibold uppercase tracking-wider text-[#78350F] hover:text-[#F59E0B]">
            {t('nav.services')}
          </a>
          <a href="#about" className="text-sm font-semibold uppercase tracking-wider text-[#78350F] hover:text-[#F59E0B]">
            {t('nav.about')}
          </a>
          <a href="#tech" className="text-sm font-semibold uppercase tracking-wider text-[#78350F] hover:text-[#F59E0B]">
            {t('nav.tech')}
          </a>
          <a href="#contact" className="text-sm font-semibold uppercase tracking-wider text-[#78350F] hover:text-[#F59E0B]">
            {t('nav.contact')}
          </a>
        </nav>
        <LanguageSelect label={t('footer.language')} />
      </div>
      <div className="mx-auto mt-8 max-w-7xl text-center text-sm text-[#78350F]/70">
        {t('footer.rights').replace('{year}', year)}
      </div>
    </footer>
  );
}
